"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import { formatDateTime } from "../lib/format-date.js";
import { useDisplayTimeZone } from "./time-zone-provider.js";
export function Time(_a) {
    var date = _a.date, _b = _a.format, format = _b === void 0 ? "monthDayYear" : _b, className = _a.className;
    var timeZone = useDisplayTimeZone().timeZone;
    return (_jsx("span", { className: className, children: formatDateTime(date, timeZone, format) }));
}
//# sourceMappingURL=time.js.map